// @flow
import * as React from 'react';
import styled from 'styled-components';
import type { TPlayersById } from '../../modules/types';
import {
	TradeInCell,
	TradeOutCell,
	TransactionPlayers,
	TransactionPlayersWrapper,
	ButtonSecondary,
	DraftOrder,
	SwitchButton, LoadingSpinner,
} from '../';
import ArrowUp from '../Icons/ArrowUp';
import ArrowDown from '../Icons/ArrowDown';
import { TransactionButtonsWrapper } from './TransactionButtonsWrapper';

type Props = {
	players_by_id: TPlayersById,
	trade: Object,
	removeWaiver: Function,
	onChangeRequestsOrder: Function,
	index: number,
	updateRequestsOrder: Function,
	last: number,
	is_rfa_order_saving: boolean,
	is_user: boolean
}

const RequestOrderWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	${DraftOrder} {
		width: 95px;
	}
`;

const TransactionButtonsWrapperStyled = styled(TransactionButtonsWrapper)`
	button {
		margin: 0;
		min-width: 50px;

		&${ButtonSecondary} {
			min-width: 150px;
		}
	}
`;

export const TradeRFA = (
	{
		trade,
		players_by_id,
		removeWaiver,
		onChangeRequestsOrder,
		index,
		updateRequestsOrder,
		last,
		is_rfa_order_saving,
		is_user
	}: Props
) => {
	const {
		id: trade_id, new_player_id, old_player_id, name
	} = trade;
	return (
		<TransactionPlayersWrapper>
			<TransactionPlayers>
				<p>
					{is_user ? 'You' : name} have requested:
				</p>
				<TradeInCell player={players_by_id[new_player_id]} />
			</TransactionPlayers>
			{is_user ? (
				<TransactionButtonsWrapperStyled>
					{is_rfa_order_saving ? (
						<LoadingSpinner />
					) : (
						<React.Fragment>
							<RequestOrderWrapper>
								<DraftOrder
									disabled
									onChange={onChangeRequestsOrder}
									name="draft_order"
									data-id={trade_id}
									value={index + 1 || '-'}
								/>
								<div>
									<SwitchButton
										up
										disabled={index === 0}
										onClick={() => updateRequestsOrder(
											{ id: trade_id, order: parseInt(index, 10)  - 1 }
										)}
									>
										<ArrowUp size='1.5'/>
									</SwitchButton>
									<SwitchButton
										disabled={index === last}
										onClick={() => updateRequestsOrder(
											{ id: trade_id, order: parseInt(index, 10) + 1 }
										)}
									>
										<ArrowDown size='1.5'/>
									</SwitchButton>
								</div>
							</RequestOrderWrapper>
							<ButtonSecondary onClick={() => removeWaiver({ trade_id })}>
								CANCEL REQUEST
							</ButtonSecondary>
						</React.Fragment>
					)}
				</TransactionButtonsWrapperStyled>
			) : null}

			<TransactionPlayers>
				<p>
					for:
				</p>
				<TradeOutCell player={players_by_id[old_player_id]} />
			</TransactionPlayers>
		</TransactionPlayersWrapper>
	);
};

export default TradeRFA;


// WEBPACK FOOTER //
// ./src/components/Trades/TradeRFA.js